import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import getCompanyIdFromToken from "../../../../utils/getCompanyIdFromToken";

const initialState = {
	list: [],
	setUp: null,
	total: 0,
	setUp: null,
	error: "",
	loading: false,
};


const companyId = getCompanyIdFromToken();

export const getOnboarding = createAsyncThunk(
	"setUp/getOnboarding",
	async (companyId) => {
		try {
			const { data } = await axios.get(`/initialSetUp/onboarding-progress?companyId=${companyId}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);


const setUpSlice = createSlice({
	name: "setUpForm",
	initialState,
	reducers: {
		clearSetUpForm: (state) => {
			state.setUp = null;
		},
	},
	extraReducers: (builder) => {

		// 2) ====== builders for getOnboarding ======

		builder.addCase(getOnboarding.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getOnboarding.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getOnboarding.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

	},
});

export default setUpSlice.reducer;
export const { clearSetUpForm } = setUpSlice.actions;
